import { InnerNavigatorOption } from "components/ui/InnerNavigator";
export function InnerOptions() {
  const options: InnerNavigatorOption[] = [
    {
      title: "Aprovados",
      route: "/checklist/avulsos-approved",
    },
    {
      title: "Reprovados",
      route: "/checklist/avulsos-rejected",
    },
  ];
  return { options };
}
